import ProductCard from '../components/layout/Guest/ProductCard';
import Category from '../components/layout/Guest/Category';
import '../style/Global.css'
import UserNavbar from '../components/layout/Guest/UserNavbar';
import ProductModal from '../components/modals/Guest/ProductModal';
import { useSelector } from 'react-redux';
import { selectCurrentModalType } from '../features/modal/modalSlice';
import { selectCurrentUserClientID } from '../features/auth/authSlice';
import CloseNotice from '../components/layout/CloseNotice';
import GuestUsername from '../components/modals/GuestUsername';
import { useStoreTimer } from '../utils/useStoreTimer';
import { useOrderSocket } from '../hooks/socket/useOrderSocket';
import { useDynamicQueryData } from '../hooks/api/useDynamicQueryData';
import { useMemo } from 'react';

export default function Home() {

    const typeModal = useSelector(selectCurrentModalType);
    const clientId = useSelector(selectCurrentUserClientID);
    const { availableProductOfClient,  chapelNameAndRemainingQty, } = useDynamicQueryData({clientId})
    const { storeOpen  } = useStoreTimer();
    useOrderSocket()
    const isSuccess = availableProductOfClient?.success === true

    const totalsByPackageType = useMemo(() => {
    return chapelNameAndRemainingQty?.packages.reduce((acc, pkg) => {
        acc[pkg.packageType] = (acc[pkg.packageType] || 0) + pkg.remainingQty;
        return acc;
    }, {} as Record<string, number>) ?? {};
    }, [chapelNameAndRemainingQty?.packages]);

    const remainingCups = totalsByPackageType["Cup-Based"] ?? 0;
    const remainingAmount = totalsByPackageType["Amount-Based"] ?? 0;

    return (
        <div className='h-screen flex flex-col bg-gray-100'>
            <UserNavbar />
            <div className='h-screen container mx-auto flex flex-col overflow-hidden pt-[75px] md:pt-[65px] lg:pt-[75px]'>
                <div className='lg:px-8 py-3 space-y-2 flex flex-col flex-1 overflow-y-auto'>
                    {!storeOpen ? (
                        <CloseNotice/>
                    ) : (
                        <> 
                            <div className="bg-white shadow-sm border text-sm font-medium text-gray-700 py-2 px-2.5 rounded">
                                {isSuccess && (
                                    <div>
                                        <span className="font-semibold text-gray-900">
                                            {chapelNameAndRemainingQty?.chapelName}
                                        </span>
                                        <span className="mx-2 text-gray-400">|</span>
                                        <span className="text-cbColor font-semibold">
                                            {`${remainingCups} remaining cups`}
                                        </span>
                                    </div>
                                )}
                                {/* Operation time */}
                                <div className="text-sm text-gray-500 mt-1">
                                    Cafe hours: <span className="font-medium text-gray-700">10:00 AM – 9:30 PM</span>
                                </div>
                            </div>

                            {/* if 10:00AM to 10:00PM display this  */}
                            <Category />
                            <div className="bg-white rounded-md w-full h-full py-2 px-2 md:p-4 flex-1 flex flex-col space-y-3 overflow-hidden">
                                <div className='w-full flex flex-col'>
                                    <div className='flex justify-between'>
                                        <p className='text-sm font-semibold'>Products</p>
                                    </div>
                                </div>
                                <ProductCard />
                            </div>
                        </>
                    )}
                </div>
            </div>
            {typeModal === 'selectedItem' && storeOpen && (
                <ProductModal />
            )}
            {typeModal === 'isNewGuest' && (
                <GuestUsername/>
            )}
        </div>
    )
}
